export default __webpack_public_path__ + "static/media/push-logo.6955025f.jpg";